import React from 'react';

import CompanyPage from '../../js/pages/HubPage/CompanyPage';
import {getCompanyResults} from '../../../server/services/search';
import JobReferrers from '../../../server/models/job_referrer';

export default function Page(props) {
  return <CompanyPage {...props} />;
}

export async function getStaticProps({params}) {
  try {
    const {
      company,
      blogPosts,
      coaches,
      courses,
      guides,
      questions,
    } = await getCompanyResults(params.company);
    const referrers = await JobReferrers.list({company: params.company, status: 'active'});

    return {
      props: {
        company,
        blogPosts,
        coaches,
        courses: JSON.parse(JSON.stringify(courses)), // serialize to make Next happy
        guides: JSON.parse(JSON.stringify(guides)), // serialize to make Next happy
        questions: JSON.parse(JSON.stringify(questions)), // serialize to make Next happy
        numReferrers: referrers.length,
      },
      revalidate: 3600,
    };
  } catch {
    return {notFound: true};
  }
}

// See https://nextjs.org/docs/api-reference/data-fetching/get-static-paths
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
